import graphql__1b37983779fb9d26ff2a from "./__generated__/AnswerBudgetDispatcher_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import BudgetDispatcherField from "../Form/Field/BudgetDispatcherField";

const AnswerBudgetDispatcher = props => {
  const { 
    dispatchedBudgetValues, 
    formField 
  } = useFragment(AnswerBudgetDispatcher_answer, props.answer);

  const {
    fieldName,
    label,
    required,
    hint,
    hintPosition,
    options,
    budget,
    maxBudgetPerOption,
    minBudgetToSpend,
    hide
  } = formField;
  const { parent } = props;

  return (
    <BudgetDispatcherField
      fieldName={fieldName}
      label={label}
      required={required}
      hint={hint}
      hintPosition={hintPosition}
      options={options}
      budget={budget}
      maxBudgetPerOption={maxBudgetPerOption}
      minBudgetToSpend={minBudgetToSpend}
      hide={hide}
      parent={parent}
      defaultValues={dispatchedBudgetValues}
    />
  );
};

const AnswerBudgetDispatcher_answer = graphql__1b37983779fb9d26ff2a;

export default AnswerBudgetDispatcher;
